import { Link } from 'react-router-dom';
import { BookOpen, ClipboardCheck, Target } from 'lucide-react';

export default function StartHereBlock() {
  return (
    <section className="bg-gradient-to-r from-gray-800/50 to-gray-800/30 rounded-2xl p-8 mb-12 border border-gray-700/50">
      <h2 className="text-2xl font-bold text-white mb-6">Start here in 3 steps</h2>

      <div className="grid gap-6 md:grid-cols-3 mb-8">
        <div className="flex gap-4">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-accent-blue/20 flex items-center justify-center">
            <BookOpen className="w-5 h-5 text-accent-blue" />
          </div>
          <div>
            <h3 className="font-semibold text-white mb-1">1. Read one lesson</h3>
            <p className="text-sm text-gray-400">
              Get a feel for how we teach: clear, practical, and focused on <em>your</em> reasoning.
            </p>
          </div>
        </div>

        <Link to="/orientation" className="flex gap-4 group">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center group-hover:bg-green-500/30 transition-colors">
            <ClipboardCheck className="w-5 h-5 text-green-400" />
          </div>
          <div>
            <h3 className="font-semibold text-white mb-1 group-hover:text-green-400 transition-colors">2. Take the Assessment</h3>
            <p className="text-sm text-gray-400">
              Get your Software 2.0 archetypes and suggested starting tracks.
            </p>
          </div>
        </Link>

        <div className="flex gap-4">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-purple-500/20 flex items-center justify-center">
            <Target className="w-5 h-5 text-purple-400" />
          </div>
          <div>
            <h3 className="font-semibold text-white mb-1">3. Commit to 2 hours</h3>
            <p className="text-sm text-gray-400">
              Pick one foundation track and complete a couple of lessons and reflections.
            </p>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-4">
        <Link
          to="/tracks/thinking-skills"
          className="inline-flex items-center gap-2 px-6 py-3 bg-accent-blue hover:bg-blue-500 text-slate-900 font-medium rounded-lg transition-colors"
        >
          View Thinking-Skills 101
        </Link>
        <a
          href="#tracks"
          className="inline-flex items-center gap-2 px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors"
        >
          Browse all foundation tracks
        </a>
      </div>
    </section>
  );
}
